export default __webpack_public_path__ + "static/media/7_Still.739f96a6.jpg";